import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Reveal } from '../hooks/useReveal';
import { IMAGES } from '../data/mock';

export default function TrialCTA() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.heroSled2} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0a0a0a]/85" />
      </div>
      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 border border-accent rounded-full text-accent font-cond text-xs tracking-widest mb-6">
            <Sparkles size={14} /> Séance d'essai offerte
          </span>
          <h2 className="font-display text-4xl md:text-6xl leading-[0.95] mb-6">
            Prêt à transpirer ?<br />
            <span className="text-accent">Rejoins le club.</span>
          </h2>
          <p className="text-[var(--hx-muted)] text-lg max-w-2xl mx-auto mb-9">
            Réserve ta première séance gratuitement, directement en ligne en 2 minutes, dans la salle de ton choix.
          </p>
          <Link to="/reserver" className="hx-btn text-base" data-cta="trialcta-reserver">
            Réserver ma séance d'essai <ArrowRight size={18} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
